// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"31d6cfe0","115":"67334598","173":"8cbc12cb","380":"905e7494","772":"5dbb2ed3","843":"aef90d31","886":"2d5123de"}[chunkId] + ".chunk.css";
};